export default __webpack_public_path__ + "locales/ro/Settings.json?hash=2b34574a250342a521cab8d465e630af";